import FloatingCard from './FloatingCard';

export { FloatingCard };
export default FloatingCard;
